module.exports = __webpack_public_path__ + "img/foodtype-bbq.4c4d10e1.png";